// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__17Sny","productName":"Table_productName__1nJ4u"};